import { lazy } from 'react';
import { ProtectedRoute } from '../components/ProtectedRoute';
import PasswordContextProvider from '../contexts/PasswordContext';

const reportRouteConfig = [
  {
    parent: {
      exact: true,
      path: '/reports/receive-receipt',
      element: ProtectedRoute,
      permission_id: 4,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import('../routes/reports/receive-receipt/ReportReceiveReceipt')),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: '/reports/cheque-report',
      element: ProtectedRoute,
      permission_id: 37,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import('../routes/reports/cheque-report/DocumentChequingReport.jsx')),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: '/reports/transaction-report',
      element: ProtectedRoute,
      permission_id: 32,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import('../routes/reports/transaction-report/TransactionReport')),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: '/reports/audit-report',
      element: ProtectedRoute,
      permission_id: 103,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import('../routes/reports/audit-report/AuditReport.jsx')),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: '/reports/transaction-for-creation-cheque-report',
      element: ProtectedRoute,
      permission_id: 89,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import('../routes/reports/creation-of-cheque-report/CreationOfChequeReport.jsx')),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: '/reports/cheques-for-releasing-to-treasury-report',
      element: ProtectedRoute,
      permission_id: 90,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import('../routes/reports/cheques-releasing-treasury/ChequesReleasingTreasuryReport.jsx')),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: '/reports/cheques-for-releasing-to-tagging-report',
      element: ProtectedRoute,
      permission_id: 91,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import('../routes/reports/cheques-releasing-tagging/ChequesReleasingTaggingReport.jsx')),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: '/reports/created-cheque-report',
      element: ProtectedRoute,
      permission_id: 92,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import('../routes/reports/created-cheque-report/CreatedChequeReport.jsx')),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: '/reports/pending-for-releasing-to-tagging-report',
      element: ProtectedRoute,
      permission_id: 93,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import('../routes/reports/pending-cheque-releasing-tagging/PendingChequesReleasingTaggingReport.jsx')),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: '/reports/pending-release-to-supplier-report',
      element: ProtectedRoute,
      permission_id: 94,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import('../routes/reports/pending-cheque-to-release-to-supplier/PendingChequesReleasingToSupplierReport.jsx')),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: '/reports/released-to-supplier-report',
      element: ProtectedRoute,
      permission_id: 95,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import('../routes/reports/cheque-released-to-supplier/PendingChequesReleasingToSupplierReport.jsx')),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: '/reports/cheque-cleared-report',
      element: ProtectedRoute,
      permission_id: 96,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import('../routes/reports/cheque-cleared/CreatedChequeReport.jsx')),
      wrapper: PasswordContextProvider,
    },
  },
];

export default reportRouteConfig;
